export const REVENUE_SCOPE_VALUES = {
  EXCLUDING: 'excluding_store_fees',
  INCLUDING: 'including_store_fees',
} as const;

export const isIncludingStoreFees = (scope?: string): boolean => {
  return scope === REVENUE_SCOPE_VALUES.INCLUDING;
};

export const getAdjustedRevenueValue = (scope?: string, adjustedRevenue?: boolean): boolean => {
  if (typeof adjustedRevenue === 'boolean') {
    return adjustedRevenue;
  }

  return isIncludingStoreFees(scope);
};

export const appendAdjustedRevenueFilter = <T extends Record<string, any>>(
  payload: T,
  scope?: string,
  adjustedRevenue?: boolean,
): T => {
  if (!payload) {
    return payload;
  }

  const filter = typeof payload.filter === 'object' && payload.filter !== null ? payload.filter : {};
  const payloadAdjustedRevenue = payload.adjusted_revenue;
  const filterAdjustedRevenue = filter.adjusted_revenue;
  const resultAdjustedRevenue = (() => {
    if (typeof payloadAdjustedRevenue === 'boolean') {
      return payloadAdjustedRevenue;
    }
    if (typeof filterAdjustedRevenue === 'boolean') {
      return filterAdjustedRevenue;
    }
    return undefined;
  })();

  return {
    ...payload,
    filter: {
      ...filter,
      adjusted_revenue: getAdjustedRevenueValue(scope, adjustedRevenue ?? resultAdjustedRevenue),
    },
  };
};
